import {Route, Routes, Outlet} from 'react-router-dom'
import {JudolListWrapper} from './judol-list/JudolList'

const JudolPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route path='' element={<JudolListWrapper />} />
      </Route>
    </Routes>
  )
}

export default JudolPage
